import React, { useReducer } from 'react';
import LiveContext from './liveContext';
import LiveReducer from './liveReducer';
import img1 from '../../../images/pastEvent.png';

const LiveState = (props) => {
  const initialState = {
    events: [
      {
        id: 1,
        src: img1,
        heading: 'Throwdown Chapter IV: Laser Jail',
      },
      {
        id: 2,
        // img: '',
        heading: 'Throwdown Chapter III: Laser Jail',
      },
      {
        id: 3,
        // img: '',
        heading: 'Throwdown Chapter III: Laser Jail',
      },
      {
        id: 4,
        // img: '',
        heading: 'Throwdown Chapter IV: Laser Jail',
      },
      {
        id: 5,
        // img: '',
        heading: 'Throwdown Chapter III: Laser Jail',
      },
      {
        id: 6,
        // img: '',
        heading: 'Throwdown Chapter III: Laser Jail',
      },
    ],
  };
  const [state] = useReducer(LiveReducer, initialState);

  return (
    <LiveContext.Provider
      value={{
        events: state.events,
      }}
    >
      {props.children}
    </LiveContext.Provider>
  );
};

export default LiveState;
